var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cw-loader"},[_c('div',{staticClass:"hero is-large"},[_c('div',{staticClass:"hero-body has-text-centered"},[_c('div',{staticClass:"main-loader pulse-loader"})])])])
}]

export { render, staticRenderFns }